module.exports = __webpack_public_path__ + "img/zk-icon-management-customer.141a869c.svg";